<p class="bulk-instructions">{{item.translation_key||item.instructions || 'Paste items copied from spreadsheet. 1 item per line with columns:'| translation|translationFromString | transformText :item?.text_transform}}</p>
<p><span *ngFor="let column of columns">"{{column.label}}" </span></p>
<div class="bulk-data-input">
<textarea pTextarea [(ngModel)]="bulk_data"  fluid></textarea>
</div>
<!--<input id="preview" type="file" (change)="importFile($event)" />-->
<button pButton severity="contrast" (click)="processData()">{{'process_data'| translation}}</button>
<div *ngIf="mapped">
  <div *ngFor="let column of columns" [style]="'display:inline-block;width:' + (90/columns.length) + '%'|safeStyle">{{column.label}}</div>
  <div *ngFor="let row of mapped">
    <div *ngFor="let column of columns" [style]="'display:inline-block;width:' + (90/columns.length) + '%'|safeStyle">
      <input [(ngModel)]="row[column.data]" style="width: 100%;padding: 5px;border-radius: 0;" />
    </div>
    <button pButton severity="contrast" (click)="remove(mapped,row);">X</button>
  </div>
  <div *ngIf="created && created.length > 0">
    <h3>{{'created'| translation}}</h3>
    <div *ngFor="let column of columns" [style]="'display:inline-block;width:' + (90/columns.length) + '%'|safeStyle">{{column.label}}</div>
    <div *ngFor="let row of created">
      <div *ngFor="let column of columns" [style]="'display:inline-block;width:' + (90/columns.length) + '%'|safeStyle">
        <div>{{row[column.data]}}</div>
      </div>
    </div>
  </div>
  <div>
    <button pButton severity="contrast"  (click)="add(mapped)">{{'row_add_new'| translation}}</button>
    <button pButton severity="contrast" (click)="createFromData()" [disabled]="mapped.length == 0">{{'items_create'| translation}}</button>
  </div>
</div>

